import { Directive, HostBinding, inject, Input } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Directive({
	selector: "[background]",
	standalone: false,
})
export class BackgroundDirective {
	private domSanitizer = inject(DomSanitizer);

	@HostBinding("class.background") backgroundClass = true;
	@HostBinding("style.background-size") backgroundSize = "cover";
	@HostBinding("style.background-repeat") backgroundRepeat = "no-repeat";
	@HostBinding("style.background-position") backgroundPosition = "center center";
	@HostBinding("style.backgroundImage") backgroundImage: any;
	@HostBinding("style.-webkit-filter")
	@HostBinding("style.-moz-filter")
	@HostBinding("style.filter")
	filter: any;

	@Input()
	set background(background: string) {
		this.backgroundImage = this.domSanitizer.bypassSecurityTrustStyle(`url(${background})`);
	}

	@Input()
	set blur(blur: string) {
		this.filter = this.domSanitizer.bypassSecurityTrustStyle(`blur(${blur}px)`);
	}
}
